export enum CinemaContentUpcomingScopeEnum {
    UNSCHEDULED = 'unscheduled',
    /**
     * Only films that have not opened at that cinema yet (CIN-14687): an entry with a cinema release
     * date drops out on that date and published showtimes do not cut it short, one without drops out
     * as soon as the cinema schedules any showing of it. Private and event-request showings do not
     * count as scheduling.
     */
    NOT_RELEASED = 'not_released'
}
